export const STARTER_OFFER_CODE_COOKIE = 'offerCode';
export const SAMPLER_OFFER_CODE_COOKIE = 'samplerOfferCode';

export const isSamplerOfferPath = pathname => {
  if (!pathname) return false;
  const path = pathname.split('?')[0];
  return (
    path === '/sampler' ||
    path.startsWith('/sampler/') ||
    path.includes('/sampler-box')
  );
};

export const getOfferCookieNameForPath = pathname =>
  isSamplerOfferPath(pathname)
    ? SAMPLER_OFFER_CODE_COOKIE
    : STARTER_OFFER_CODE_COOKIE;

export const resolveFlagshipOfferCode = ({
  pathname,
  urlOfferCode,
  getCookie,
} = {}) => {
  const queryCode = Array.isArray(urlOfferCode)
    ? urlOfferCode[0]
    : urlOfferCode;
  if (queryCode) return String(queryCode);

  const stored = getCookie?.(getOfferCookieNameForPath(pathname));
  return stored ? String(stored) : '';
};

export const resolveSamplerDisplayOfferCode = ({
  pathname,
  urlOfferCode,
  getCookie,
} = {}) => {
  const queryCode = Array.isArray(urlOfferCode)
    ? urlOfferCode[0]
    : urlOfferCode;
  if (queryCode) return String(queryCode);

  if (!isSamplerOfferPath(pathname)) return null;

  const stored = getCookie?.(SAMPLER_OFFER_CODE_COOKIE);
  return stored ? String(stored) : null;
};

export const shouldApplyOfferToStarterCart = pathname =>
  !isSamplerOfferPath(pathname);

export const shouldHydrateExistingStarterCart = ({
  savedCartId,
  shouldCreateCart,
  pathname,
} = {}) =>
  Boolean(savedCartId) &&
  !shouldCreateCart &&
  shouldApplyOfferToStarterCart(pathname);

const sameOfferCode = (left, right) =>
  Boolean(left && right && left.toLowerCase() === right.toLowerCase());

export const resolveStarterOfferCodeToApply = ({
  urlOfferCode,
  storedOfferCode,
  samplerOfferCode,
  defaultOfferCode,
  cartOfferCode,
}) => {
  if (urlOfferCode) return urlOfferCode;

  if (sameOfferCode(storedOfferCode, samplerOfferCode)) {
    return defaultOfferCode;
  }

  if (storedOfferCode) return storedOfferCode;

  // The starter offerCode cookie is session-scoped. A cart coupon that matches
  // the sampler cookie is still a sampler code and must not stay on the
  // starter cart after that cookie is gone.
  if (sameOfferCode(cartOfferCode, samplerOfferCode)) {
    return defaultOfferCode;
  }

  // A missing offerCode cookie is not a reason to replace some other coupon
  // already on the cart. shopifyCartId lasts 30 days.
  if (cartOfferCode) return cartOfferCode;

  return defaultOfferCode;
};
